export default function HeroSection() {
  const stats = [
    { label: '聚合站点', value: '6+' },
    { label: '每日更新', value: '200+' },
    { label: '影片覆盖', value: '10万+' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20film%20light%20streaks%2C%20abstract%20geometric%20film%20strip%20elements%2C%20luxurious%20dark%20velvet%20curtains%20with%20subtle%20gold%20accents%2C%20deep%20charcoal%20background%20with%20soft%20warm%20glow%2C%20elegant%20cinema%20aesthetic%2C%20dramatic%20lighting%2C%20no%20people%2C%20atmospheric%20and%20immersive&width=1800&height=900&seq=hero-bg-51cinema&orientation=landscape"
          alt="51影院 - 影视资源免费高清在线看"
          className="w-full h-full object-cover object-top"
          title="51影院 - 奇优影院与98影院免费高清在线看"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-background-50"></div>
      </div>

      <div className="relative w-full z-10 px-4 md:px-6 pt-20 pb-12">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-400 text-sm font-medium mb-6 border border-primary-500/30">
              奇优影院 · 98影院 · 优优色影院 · cc影院 · 96影院
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-50 leading-tight mb-4">
              51影院
              <br />
              <span className="text-primary-400">免费高清影视聚合平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-300 mb-3 leading-relaxed">
              一站式整合六大热门站点资源，覆盖电影、电视剧、综艺、动漫等全品类内容
            </p>
            <p className="text-sm md:text-base text-foreground-400 mb-8 leading-relaxed">
              每日不间断更新，cc影院、96影院最新片源同步上线，从经典老片到热映新作，满足每一位影迷的多样化观影需求
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">{s.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap text-sm"
              >
                <i className="ri-fire-line"></i>
                探索热门排行
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-200/50 hover:bg-background-200 text-foreground-200 font-medium rounded-lg border border-background-200/60 transition-all whitespace-nowrap text-sm"
              >
                <i className="ri-hashtag"></i>
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[460px] aspect-[4/3] rounded-xl overflow-hidden border border-background-200/30">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20poster%20collage%20with%20warm%20golden%20and%20amber%20lighting%2C%20vintage%20cinema%20aesthetic%2C%20abstract%20film%20frames%20floating%20in%20dark%20space%2C%20elegant%20golden%20film%20strip%20winding%20through%20composition%2C%20dramatic%20shadow%20play%2C%20sophisticated%20movie%20theater%20vibe%2C%20no%20text%2C%20artistic%20rendering&width=920&height=690&seq=hero-visual-cinema&orientation=landscape"
                alt="51影院主视觉 - 电影胶片艺术"
                className="w-full h-full object-cover"
                title="51影院 - 多站聚合影视平台"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}